import { message } from 'antd';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';
import companies from '../companies';

export function setSelectedYear(year) {
    return {
        type: t.SET_REPORTS_SELECTEDYEAR,
        payload: year
    };
}
export function setSelectedDetailReportIsDirty(isdirty) {
    return {
        type: t.SET_SELECTED_DETAIL_REPORT_DIRTY,
        payload: isdirty
    };
}

export function loadMyReports(year) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.REPORTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/my?year=${year}&lang=${lang}`);
        dispatch({
            type: t.LOAD_MYREPORTS,
            payload: resp.data
        });
        dispatch({
            type: t.REPORTS_LOADING,
            payload: false
        });
    };
}
export function loadManagerReports(year) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.REPORTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/manager?year=${year}&lang=${lang}`);
        dispatch({
            type: t.LOAD_REPORTS,
            payload: resp.data
        });
        dispatch({
            type: t.REPORTS_LOADING,
            payload: false
        });
    };
}
export function loadComplianceReports(year) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.REPORTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports?year=${year}&lang=${lang}`);
        dispatch({
            type: t.LOAD_COMPLIANCE_REPORTS,
            payload: resp.data
        });
        dispatch({
            type: t.REPORTS_LOADING,
            payload: false
        });
    };
}
export function loadDelegatedWaitingForApprovalReports() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.REPORTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/delegatedwaitingforapproval?lang=${lang}`);
        dispatch({
            type: t.LOAD_DELEGATED_REPORTS,
            payload: resp.data
        })
    };
}
export function loadWaitingForApprovalReports() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.REPORTS_LOADING,
            payload: true
        })
        let lang = getState().uistate.appsettings.lang

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/waitingforapproval?lang=${lang}`);
        dispatch({
            type: t.LOAD_WAITING_REPORTS,
            payload: resp.data
        })
    };
}
export function loadNextWaitingForApprovalReport(year) {
    return async (dispatch, getState) => {

        let apprOrder = getState()[constants.NAME].approvalorder;
        let nextid = apprOrder.shift(); //remove and get first item from array..

        //set new/remaing approvalorder
        dispatch({
            type: t.SET_REPORTS_APPROVALORDER,
            payload: apprOrder
        });

        return nextid;
    }
}

export function setApprovalOrderReports(ids) {
    return {
        type: t.SET_REPORTS_APPROVALORDER,
        payload: ids
    };
}

export function clearSelectedDetailReport() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.LOAD_REPORTDETAILS,
            payload: {}
        });
    };
}

export function loadReportDetails(idReport) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.DETAILS_LOADING,
            payload: true
        });
        const lang = getState().uistate.appsettings.lang
        try {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/details/${idReport}?lang=${lang}`);
            dispatch({
                type: t.LOAD_REPORTDETAILS,
                payload: resp.data
            });
            dispatch({
                type: t.DETAILS_LOADING,
                payload: false
            });
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function createNewReport(values) {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports`, values);
        return resp.data
    };
}

export function updateReportDetails(report) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports`, report);
            message.success('data saved.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}
export function deleteReport(id) {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reports/${id}`);
        return resp.data
    };
}

//#region File-actions

export function uploadReportFile(file, idReport) {
    return async function (dispatch, getState) {
        try {
            //formdata en header instellen
            const formData = new FormData();
            formData.append('file', file);

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            };

            await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/files/upload/report/${idReport}`, formData, config)
        } catch (error) {
            message.error('Error saving file (to big?).', 5)
            AppInsights.trackException(error);
        }
    };
}
export function deleteLinkedReportFiles(idReport) {
    return async function (dispatch, getState) {
        try {
            let resp = await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/files/delete/report/${idReport}`);
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function getLinkedFile(idlinkedfile) {
    return async function (dispatch, getState) {
        try {
            let resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/files/download/report/${idlinkedfile}`);
            return resp.data;
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#endregion

//#region Workflow-Actions

export function submitNewReportForApproval(idReport) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/submitforapproval/${idReport}`);
            const result = resp.data; //{ idReport(int) , workflowInstanceId(guid), workflowDefinitionName(string) }
            message.success('Report submitted, starting workflow.');
            try {
                let wfresp = await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/StartWorkflow/${result.workflowInstanceId}/${result.workflowDefinitionName}`);
                if (wfresp.data.length < 20) {
                    throw 'No valid response when starting workflow...'
                }
                message.success('Workflow is started', 10);
            } catch (err) {
                //console.log(err);
                AppInsights.trackException('Error on workflow start. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/compensateforsubmiterror/${idReport}/1`); //reset to concept always
                message.error('Error submitting report.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}
export function submitReportForApproval() {
    return async (dispatch, getState) => {
        const report = getState()[constants.NAME].selectedDetailReport;
        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/submitforapproval/${report.idReport}`);
            const result = resp.data; //{ idReport(int) , workflowInstanceId(guid), workflowDefinitionName(string) }
            message.success('Report submitted, starting workflow.');
            try {
                let wfresp = await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/StartWorkflow/${result.workflowInstanceId}/${result.workflowDefinitionName}`);
                if (wfresp.data.length < 20) {
                    throw 'No valid response when starting workflow...'
                }
                message.success('Workflow is started', 10);
            } catch (err) {
                //console.log(err);
                AppInsights.trackException('Error on workflow start. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/compensateforsubmiterror/${report.idReport}/${report.idReportStatus}`);
                message.error('Error submitting expense report.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function rejectReport(remark, workflowinstanceid, stepid) {
    return async (dispatch, getState) => {
        const report = getState()[constants.NAME].selectedDetailReport;
        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/reject/${report.idReport}`);
            let wfmessage = { message: remark };
            try {
                await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/RunWorkflowTask/${workflowinstanceid}/${stepid}/`, wfmessage);
                message.success('Workflow action completed', 10);
            } catch (err) {
                AppInsights.trackException('Error on workflow start. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/compensateforsubmiterror/${report.idReport}/${report.idReportStatus}`);
                message.error('Error submitting workflow action.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}
export function approveReport(workflowinstanceid, stepid) {
    return async (dispatch, getState) => {
        const report = getState()[constants.NAME].selectedDetailReport;
        try {
            await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/approve/${report.idReport}`);
            let wfmessage = { message: 'approved by user' };
            try {
                await common.wfApiClient.post(`${common.SETTINGS.REMOTERESOURCES.WF.ROOT_URL}/api/RunWorkflowTask/${workflowinstanceid}/${stepid}/`, wfmessage);
                message.success('Workflow action completed', 10);
            } catch (err) {
                AppInsights.trackException('Error on workflow start. ' + err);
                //compensate to old state...
                await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/tasks/reports/compensateforsubmiterror/${report.idReport}/${report.idReportStatus}`);
                message.error('Error submitting workflow action.');
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

//#endregion